var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeasubmissionapproval3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "398px",
    height: "398px",
    viewBox: "0 0 398 398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Idea submission &amp; approval") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.37479173,0.290018998 L113.977735,6.15013758 C116.790296,6.30190086 118.947299,8.70496025 118.795535,11.5175209 C118.79387,11.5483891 118.791923,11.5792415 118.789697,11.6100742 L113.381772,86.4954796 C113.189159,89.1626531 110.969138,91.2281346 108.295019,91.2281346 L5.1,91.2281346 C2.28334778,91.2281346 2.12129725e-15,88.9447868 0,86.1281346 L0,5.38261063 C-3.44940413e-16,2.5659584 2.28334778,0.282610627 5.1,0.282610627 C5.19164717,0.282610627 5.28327769,0.285080981 5.37479173,0.290018998 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Landing_page-1",
    transform: "translate(-586.000000, -1498.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(165.000000, 1498.906548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Idea-submission-&-approval",
    transform: "translate(421.906548, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.343452,58.0934521 C231.834847,58.0934521 258.984988,85.2435924 258.984988,118.734988 C258.984988,128.5307 256.611963,138.180615 252.068927,146.85914 C243.085277,164.020577 238.593452,181.182015 238.593452,198.343452 C238.593452,215.50489 243.085277,232.666327 252.068927,249.827764 C267.601479,279.499525 256.139374,316.144858 226.467609,331.677401 C217.789079,336.220428 208.139164,338.593452 198.343452,338.593452 C120.885516,338.593452 58.0934521,275.801388 58.0934521,198.343452 C58.0934521,120.885516 120.885516,58.0934521 198.343452,58.0934521 Z",
    id: "Rectangle",
    fill: "#6551FF",
    opacity: 0.100000001,
    transform: "translate(198.343452, 198.343452) scale(-1, 1) rotate(-45.000000) translate(-198.343452, -198.343452) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(58.943452, 79.993452)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1D058B",
    x: 0,
    y: 208.88685,
    width: 278.8,
    height: 11.9363914,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7446101,63.2303459 L258.20883,56.4200873 C261.024354,56.340348 263.371428,58.5581392 263.451167,61.3736625 C263.45253,61.4217773 263.453211,61.469909 263.453211,61.5180432 L263.453211,203.78685 C263.453211,206.603502 261.169863,208.88685 258.353211,208.88685 L17.8889908,208.88685 C15.0723386,208.88685 12.7889908,206.603502 12.7889908,203.78685 L12.7889908,68.3283018 C12.7889908,65.5678774 14.9852921,63.3084934 17.7446101,63.2303459 Z",
    id: "Rectangle-Copy-14",
    fill: "#190089",
    opacity: 0.979785159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.806391,67.8506116 L250.556496,62.3660944 C253.372325,62.2979865 255.710217,64.5254544 255.778325,67.341283 C255.779319,67.3823822 255.779817,67.423492 255.779817,67.4646032 L255.779817,199.523853 C255.779817,202.340505 253.496469,204.623853 250.679817,204.623853 L25.760808,204.623853 C22.9729234,204.623853 20.7016684,202.385218 20.6613416,199.597625 L18.8302447,73.022892 C18.7897815,70.2258666 21.0098909,67.9182519 23.806391,67.8506116 Z",
    id: "Rectangle-Copy-14",
    fill: "#A8C7FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(34.809174, 74.176147)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 51.400028,
    y: 0,
    width: 75,
    height: 70,
    rx: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 131.400028,
    y: 0,
    width: 75,
    height: 70,
    rx: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 51.400028,
    y: 74,
    width: 75,
    height: 70,
    rx: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 131.400028,
    y: 74,
    width: 75,
    height: 70,
    rx: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#C6D9FF",
    x: 0,
    y: 0,
    width: 48.2369494,
    height: 121.921713,
    rx: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#FFFFFF",
    opacity: 0.511300223,
    x: 59.516955,
    y: 94.7364658,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#FFFFFF",
    opacity: 0.511300223,
    x: 59.516955,
    y: 102.974419,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#FFFFFF",
    opacity: 0.511300223,
    x: 59.516955,
    y: 79.0843541,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#FFFFFF",
    opacity: 0.511300223,
    x: 59.516955,
    y: 68.3750145,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    fill: "#7995FB",
    x: 59.516955,
    y: 60.1370609,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#FFFFFF",
    opacity: 0.511300223,
    x: 59.516955,
    y: 87.3223076,
    width: 32.4215561,
    height: 4.11897677,
    rx: 2.05948839
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#CDDFFF",
    x: 97.4738987,
    y: 102.974419,
    width: 104.381595,
    height: 4.11897677,
    rx: 2.05948839
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(67.150000, 128.350000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.2794186,0.185845605 L60.5294186,2.13075099 C63.2745414,2.22738455 65.45,4.48077095 65.45,7.22759403 L65.45,93.9764648 C65.45,96.7931171 63.1666522,99.0764648 60.35,99.0764648 L5.1,99.0764648 C2.28334778,99.0764648 -5.43238007e-16,96.7931171 0,93.9764648 L0,5.28268864 C1.43141643e-15,2.46603642 2.28334778,0.182688644 5.1,0.182688644 C5.15982009,0.182688644 5.21963554,0.183741127 5.2794186,0.185845605 Z",
    id: "Rectangle",
    fill: "#130072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80510004,6.2119857 L59.7381642,8.21974217 C61.1340848,8.27370911 62.2267264,9.4407888 62.1887092,10.8372348 L60.228872,82.825861 C60.1912812,84.206647 59.0611141,85.3064648 57.6798165,85.3064648 L5.55371434,85.3064648 C4.14538823,85.3064648 3.00371434,84.164791 3.00371434,82.7564648 C3.00371434,82.7317412 3.0040739,82.7070189 3.00479291,82.6823057 L5.15766802,8.68592302 C5.19862499,7.27819259 6.37301817,6.17020378 7.7807486,6.21116075 C7.78886701,6.21139695 7.79698425,6.21167194 7.80510004,6.2119857 Z",
    id: "Rectangle",
    fill: "#A8C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 7.18353659,
    y: 21.0464648,
    width: 28.7341463,
    height: 24.48,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#C6D9FF",
    x: 7.18353659,
    y: 47.8214648,
    width: 50.2847561,
    height: 16.83,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    fill: "#C6D9FF",
    x: 7.18353659,
    y: 66.9464648,
    width: 50.2847561,
    height: 15.3,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#C6D9FF",
    x: 37.5140244,
    y: 21.0464648,
    width: 21.5506098,
    height: 24.48,
    rx: 2.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(17.904587, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FF6F6A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.045413, 39.100000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    cx: 20.825,
    cy: 20.825,
    r: 20.825
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FF655A",
    strokeWidth: 2.55,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "32.3 11.9 15.2344483 28.9 7.65 21.3446849"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#F63F40",
    mask: "url(#mask-2)",
    x: -0.790489499,
    y: -0.793288127,
    width: 120.154404,
    height: 29.3516607
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.10948,177.532181 C174.065933,167.275267 179.923351,162.14681 184.681735,162.14681 C191.81931,162.14681 238.70658,160.866807 248.394223,165.713164 C258.081867,170.559522 268.568807,202.471328 268.568807,213.644778 C268.568807,221.093744 265.915241,229.869667 260.608109,239.972545 C250.052766,229.906513 244.775095,224.873496 244.775095,224.873496 C244.775095,224.873496 236.555283,238.84952 228.063623,238.84952 C219.571962,238.84952 220.145195,218.243578 199.603241,238.84952 C185.908606,252.586815 175.077352,232.147702 167.10948,177.532181 Z",
    id: "Path-10",
    fill: "#FF5B50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75107,123.612318 L188.656977,146.945274 L203.072679,160.926472 L204.410187,167.232791 C204.402732,169.424182 207.369745,170.519878 213.311224,170.519878 C222.223442,170.519878 230.201835,168.123068 230.201835,165.414083 C230.201835,162.705098 219.434687,137.854432 217.095495,136.879753 C214.756303,135.905073 212.120615,138.878828 211.322891,136.879753 C210.791075,135.547035 209.893749,130.119046 208.630911,120.595783 L197.683707,113.395719 L187.839205,114.625919 L180.75107,123.612318 Z",
    id: "Path-8",
    fill: "#EABDBD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-56",
    transform: "translate(19.609786, 199.670336)",
    fill: "#403EFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81463065,1.14486828 C1.75890255,0.0251869717 1.0768607,0.144503615 0.768505113,1.50281821 C0.460149523,2.8611328 0.203981153,4.77019909 0,7.23001708 L0.768505113,7.23001708 L1.40731532,8.40171812 L1.40731532,10.5616008 L6.67029966,10.5616008 L5.46023269,9.23151993 L3.35399521,9.23151993 L2.81463065,1.14486828 Z",
    id: "Path-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    points: "20.9465965 7.29015886 19.9763008 7.29015886 19.6552527 10.5616008 25.7957555 10.9986439 28.8844657 11.3169505 29.8644257 10.5616008 26.9419414 9.58598898 22.8518165 9.30355469"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.94182,121.921713 C218.23287,126.442142 218.545315,131.241172 214.879156,136.318802 C209.379917,143.935248 208.912019,132.331756 210.227523,136.318802 C211.543028,140.305849 205.521977,123.226396 211.805666,122.574054 C215.994793,122.13916 216.706844,121.921713 213.94182,121.921713 Z",
    id: "Path-9",
    fill: "#EAB3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.170968,107.667203 C185.200445,104.261693 182.482068,102.558937 179.015838,102.558937 C173.816492,102.558937 168.160533,107.463787 168.876242,113.510867 C169.591951,119.557948 174.282416,124.059065 177.709135,123.541031 C181.135854,123.022998 186.583064,120.002364 188.878522,117.989124 C191.17398,115.975885 198.384902,114.61164 201.55021,125.728628 C204.715517,136.845616 205.119459,144.158526 201.55021,144.158526 C197.98096,144.158526 187.170968,143.039543 187.170968,145.955951 C187.170968,148.872358 193.672378,164.551682 195.230439,164.551682 C196.788499,164.551682 209.337029,157.308514 211.009727,155.94117 C212.682426,154.573825 213.971321,150.361753 213.326873,146.696773 C212.682426,143.031794 210.173184,134.410045 209.489621,130.069337 C208.806057,125.728628 211.177423,122.602605 213.326873,122.602605 C215.476324,122.602605 218.862386,120.758685 218.174949,117.989124 C217.487512,115.219564 211.58059,113.613544 210.024078,111.662298 C208.467567,109.711052 211.862923,101.459327 203.872778,101.459327 C195.882632,101.459327 194.899967,107.088339 193.540061,107.088339 C192.633457,107.088339 190.510426,107.281294 187.170968,107.667203 Z",
    id: "Path-7",
    fill: "#6551FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.895413,239.697804 C258.345257,234.093736 255.785072,230.102486 253.214856,227.724056 C250.644641,225.345626 247.306831,223.897954 243.201425,223.38104 C241.988027,228.057994 240.198514,231.107684 237.832888,232.530109 C235.467261,233.952534 231.234239,235.5336 225.13382,237.273305 C221.464476,230.907139 217.220671,227.724056 212.402404,227.724056 C207.584137,227.724056 203.286088,231.307188 199.508257,238.473452 L201.328759,238.473452 L218.62027,238.473452 L217.540953,244.783397 C225.963176,246.93096 233.28155,247.678351 239.496074,247.025571 C245.710598,246.372791 252.843711,243.930202 260.895413,239.697804 Z",
    id: "Path-11",
    fill: "#FFA8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.627293,244.696024 C124.482293,244.696024 122.566546,243.353865 121.833958,241.337844 L100.135174,181.624694 C99.1731939,178.977408 100.539404,176.05152 103.18669,175.089539 C103.745006,174.886656 104.334474,174.782875 104.92851,174.782875 L168.923198,174.782875 C170.958734,174.782875 172.79934,175.993282 173.605827,177.862235 L199.373132,237.575385 C199.491804,237.850396 199.584379,238.130099 199.651956,238.41173 L219.118043,238.411696 L219.118043,244.696024 L126.627293,244.696024 Z",
    id: "Combined-Shape",
    fill: "#1C0089"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E3ECFF",
    opacity: 0.31749907,
    transform: "translate(142.940790, 209.068053) rotate(-14.000000) translate(-142.940790, -209.068053) ",
    cx: 142.94079,
    cy: 209.068053,
    rx: 5.92362881,
    ry: 9.0855823
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeasubmissionapproval3X);
export default __webpack_public_path__ + "static/media/Idea submission & approval@3x.9d653ddf929182ab399996bafc08c16e.svg";
export { ForwardRef as ReactComponent };